<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-tabs content-class="mt-3">
              <b-tab title="Orders" active>
                <div class="row mt-4">
                  <!-- Date Selector -->
                  <div class="col-12">
                    <h3 class="m-0">Orders</h3>
                    <p>Rep orders list</p>
                    <small class="text-muted">Maximum 1 year range</small>
                    <div class="row">
                      <div class="col-md-4">
                        <label for="from">From</label>
                        <b-form-datepicker
                                           id="from"
                                           v-model="from"
                                           class="mb-2"></b-form-datepicker>
                      </div>
                      <div class="col-md-4">
                        <label for="to">To</label>
                        <b-form-datepicker
                                           id="to"
                                           v-model="to"
                                           class="mb-2"></b-form-datepicker>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="row mt-5">
                      <div class="col-auto">
                        <button @click="repOrders" class="btn btn-primary">
                          <i class="lni lni-empty-file"></i> ORDERS
                        </button>
                      </div>
                      <div class="col-auto">
                        <b-form-select
                                       v-model="user_id"
                                       :options="reps"
                                       text-field="name"
                                       value-field="id" />
                      </div>
                    </div>
                  </div>



                  <div class="col-12 border-top mt-3">
                    <div class="row pt-3">
                      <div class="col-auto">
                        <button @click="repOrderProducts" class="btn btn-primary">
                          <i class="lni lni-package"></i> PRODUCTS
                        </button>


                      </div>
                      <div class="col-auto pt-2">
                        <p>Product totals grouped by customer for all reps</p>
                      </div>

                    </div>
                  </div>

                </div>
              </b-tab>
              <b-tab title="Rep Movements">
                <div class="row mt-4">
                  <!-- Date Selector -->
                  <div class="col-12">
                    <h3 class="m-0">Movements</h3>
                    <p>Rep clocking and order creation movement</p>
                    <small class="text-muted">Maximum 1 year range</small>
                    <div class="row">
                      <div class="col-md-4">
                        <label for="from">From</label>
                        <b-form-datepicker
                                           id="from"
                                           v-model="from"
                                           class="mb-2"></b-form-datepicker>
                      </div>
                      <div class="col-md-4">
                        <label for="to">To</label>
                        <b-form-datepicker
                                           id="to"
                                           v-model="to"
                                           class="mb-2"></b-form-datepicker>
                      </div>
                      <div class="col-md-4">
                        <label for="to">Rep</label>
                        <b-form-select
                                       v-model="user_id"
                                       :options="reps"
                                       text-field="name"
                                       value-field="id" />
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="row mt-5">
                      <div class="col-auto">
                        <button @click="repMovements('xlsx')" class="btn btn-primary">
                          <i class="lni lni-empty-file"></i> XLSX
                        </button>
                        <button @click="repMovements('pdf')" class="btn btn-primary ml-2">
                          <i class="lni lni-empty-file"></i> PDF
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Engagements">
                <div class="row mt-4">
                  <div class="col-12">
                    <h3 class="m-0">Details</h3>
                    <p>Engagements details report with movements</p>
                    <small class="text-muted">Maximum 1 year range</small>
                    <div class="row">
                      <div class="col-md-6">
                        <label for="from">From</label>
                        <b-form-datepicker
                                           id="from"
                                           v-model="from"
                                           class="mb-2"></b-form-datepicker>
                      </div>
                      <div class="col-md-6">
                        <label for="to">To</label>
                        <b-form-datepicker
                                           id="to"
                                           v-model="to"
                                           class="mb-2"></b-form-datepicker>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="row mt-5">
                      <div class="col-auto">
                        <button
                                @click="engagements"
                                class="btn btn-sm btn-primary">
                          <i class="lni lni-empty-file"></i> CSV
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Pallets">
                <div class="row mt-4">
                  <div class="col-12">
                    <h3 class="m-0">Damaged & Discrepancy</h3>
                    <p>Damaged pallets and inter branch transfer discrepancy</p>
                    <small class="text-muted">Maximum 1 year range</small>
                    <div class="row">
                      <div class="col-md-6">
                        <label for="from">From</label>
                        <b-form-datepicker
                                           id="from"
                                           v-model="from"
                                           class="mb-2"></b-form-datepicker>
                      </div>
                      <div class="col-md-6">
                        <label for="to">To</label>
                        <b-form-datepicker
                                           id="to"
                                           v-model="to"
                                           class="mb-2"></b-form-datepicker>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="row mt-5">
                      <div class="col-auto">
                        <button
                                @click="damagedPallets"
                                class="btn btn-primary mr-3">
                          <i class="lni lni-empty-file"></i> Damaged
                        </button>
                        <button
                                @click="discrepancyPallets"
                                class="btn btn-info">
                          <i class="lni lni-empty-file"></i> Discrepancy
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reportingRepo from "@/api/repos/reportingRepo";

export default {
  data() {
    return {
      from: this.moment().subtract(7, "days").format("YYYY-MM-DD"),
      to: this.moment().format("YYYY-MM-DD"),
      company_id: localStorage.getItem("current_company_id"),
      loading: false,
      user_id: null,
      reps: [],
    };
  },

  mounted() {
    this.getReps();
  },

  methods: {
    async getReps() {
      let { data } = await reportingRepo.getReps();
      this.reps = [
        { id: null, name: "All reps" },
        ...data.reps,
      ];
      if (this.reps.length > 0) {
        this.user_id = this.reps[0].id;
      }
    },
    checkRange() {
      //from is not greate
      if (this.moment(this.from).isAfter(this.moment(this.to))) {
        this.$root.$bvToast.toast("From can not be after to", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return false;
      }

      //not more then a year
      if (this.moment(this.to).diff(this.moment(this.from), "days") > 366) {
        this.$root.$bvToast.toast("Range can not be greater than 1 year", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return false;
      }

      return true;
    },
    async repMovements(type) {
      if (this.checkRange()) {

        // base URL
        let url = `/reports/rep-movements?cid=${this.company_id}&type=${type}&from=${this.from}&to=${this.to}`;

        // Only send user_id if a specific rep is chosen (not "All reps")
        if (this.user_id !== null) {
          url += `&user_id=${this.user_id}`;
        }

        window.open(url);

        // try {
        //   let response = await reportingRepo.repMovements({
        //     from: this.from,
        //     to: this.to,
        //     user_id: this.user_id,
        //   });
        //   var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        //   var fileLink = document.createElement("a");

        //   fileLink.href = fileURL;
        //   fileLink.setAttribute("download", `rep_movements.csv`);
        //   document.body.appendChild(fileLink);

        //   fileLink.click();
        // } catch (err) {
        //   console.log(err);
        // }
      }
    },
    async repOrders() {
      if (this.checkRange() && this.user_id != null) {
        try {
          let response = await reportingRepo.repOrders({
            from: this.from,
            to: this.to,
            user_id: this.user_id,
          });
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", `rep_orders.csv`);
          document.body.appendChild(fileLink);

          fileLink.click();
        } catch (err) {
          console.log(err);
        }
      }
    },
    async repOrderProducts() {
      if (this.checkRange() && this.user_id != null) {
        try {
          let response = await reportingRepo.repOrderProducts({
            from: this.from,
            to: this.to,
          });
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", `rep_order_products.csv`);
          document.body.appendChild(fileLink);

          fileLink.click();
        } catch (err) {
          console.log(err);
        }
      }
    },
    async engagements() {
      if (this.checkRange() && this.user_id != null) {
        try {
          let response = await reportingRepo.engagements({
            from: this.from,
            to: this.to,
          });
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", `engagements.csv`);
          document.body.appendChild(fileLink);

          fileLink.click();
        } catch (err) {
          console.log(err);
        }
      }
    },
    async damagedPallets() {
      if (this.checkRange() && this.user_id != null) {
        try {
          let response = await reportingRepo.palletDamages({
            from: this.from,
            to: this.to,
          });
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", `damaged.csv`);
          document.body.appendChild(fileLink);

          fileLink.click();
        } catch (err) {
          console.log(err);
        }
      }
    },
    async discrepancyPallets() {
      if (this.checkRange() && this.user_id != null) {
        try {
          let response = await reportingRepo.palletDiscrepancies({
            from: this.from,
            to: this.to,
          });
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", `discrepancies.csv`);
          document.body.appendChild(fileLink);

          fileLink.click();
        } catch (err) {
          console.log(err);
        }
      }
    },
  },
};
</script>

<style></style>